<template>
    <div class="main tea_user_screen">
        <div class="main_container">
            <!--顶部返回、时间选择器-->
            <div class="top_area">
                <!--返回-->
                <div class="top_back">
                    <div class="top_back_area" v-on:click="gotoBack">
                        <img src="../../../../assets/images/back.png"/>
                        <span class="click-text">返回</span>
                    </div>
                </div>
                <!--月份选择器-->
                <div class="school_month_selected">
                    请选择月份:
                    <Select
                        v-model="month"
                        placeholder="请选择月份"
                        @on-change="search"
                        style="width: 140px;margin-left: 10px;"
                    >
                        <Option
                            v-for="item in monthList"
                            :value="item.month_name_num"
                            :key="item.month_name_num"
                        >{{ item.month_name_num }}
                        </Option>
                    </Select>
                </div>
            </div>
            <!--表格-->
            <card class="card_area">
                <div class="tab_top_title">
                    <span>大屏使用场景详情数据</span>
                </div>
                <!--教师使用大屏的场景详情-->
                <div class="school_table_wrapper_data">
                    <Table :columns="columns" :data="schoolUseDetail"></Table>
                </div>
                <!--分页-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </card>
        </div>
    </div>
</template>

<script>
    import {findClassUsageRate, findCalendar} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "school-use-pro-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId, //学校ID
                schoolName: this.$route.query.schoolName, //学校ID
                startDate:this.$route.query.startDate,
                endDate:this.$route.query.endDate,
                month:this.$route.query.currMonth,
                dateList: [],
                columns: [],
                schoolUseDetail: [],
                monthList: [],
                // month: 0,
                startTime: "",//开始时间
                endTime: "",//结束时间
                seleStartDate: "",//选择的开始时间
                seleEndDate: "",//选择的结束时间
                diskId: "",//硬盘id
            };
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             * 返回主页
             */
            gotoBack(){
                this.$router.push({
                    name: "boardMain",
                    query: {
                        startDate:this.startDate,
                        endDate:this.endDate,
                        schoolId:this.schoolId,
                        schoolName: this.schoolName
                    }
                })
            },
            /**
             * 更新时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.startDate = startDate;
                this.endDate = endDate;
                this.getClassUsageRate();
            },
            /**
             * 查询按钮点击事件
             */
            search () {
                //选择完日期后重新请求接口
                this.getClassUsageRate();
            },
            /**
             * 获取日期下拉框数据
             */
            async getCalendar () {
                let _this = this;
                await findCalendar()
                    .then(function (data) {
                        _this.monthList = data;
                        // _this.month = _this.monthList[0].month_name_num;
                        //获取学校使用率
                        _this.getClassUsageRate();
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取学校产品使用详情
             */
            async getClassUsageRate () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.month
                };
                await findClassUsageRate(params)
                    .then(function (data) {
                        //清空列
                        _this.columns = [];
                        _this.columns.push(
                            {
                                title: "使用班级",
                                key: "className",
                                width: 150,
                                className: "demo-table-info-left-column",
                                fixed: "left",
                                align: "center",
                                type: "html",
                            },
                            {
                                title: "总计",
                                key: "totalCount",
                                fixed: "right",
                                align: "center",
                                className: "demo-table-info-right-column",
                                width: 120
                            }
                        );
                        _this.schoolUseDetail = [];
                        for (let i = 0; i < data.length; i++) {
                            let classObj = {};
                            classObj.className = data[i].className + "</br>" + '(' + data[i].version + ')';
                            classObj.totalCount = data[i].counts;
                            classObj.diskId = data[i].diskId;
                            for (let j = 0; j < data[i].classInfo.length; j++) {
                                classObj["day" + j] = data[i].classInfo[j].count;
                                _this.startTime = data[i].classInfo[0].time;
                                _this.endTime = data[i].classInfo[data[i].classInfo.length - 1].time;
                                if (i === 0) {
                                    _this.columns.push({
                                        title: data[i].classInfo[j].day,
                                        key: "day" + j,
                                        align: "center",
                                        width: 100,
                                        render: (h, params) => {
                                            return h("div", [
                                                h(
                                                    "div",
                                                    {
                                                        attrs: {
                                                            title: "点击进入各班级使用产品详情页面",
                                                            href: "javascript:void(0);"
                                                        },
                                                        style: {
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                        },
                                                        on: {
                                                            click: () => {
                                                                _this.goProUseDetails(params.row, params.index, data[i].classInfo[j].time, params.row["day" + j]);
                                                            }
                                                        }
                                                    },
                                                    params.row["day" + j]
                                                )
                                            ]);
                                        }
                                    });
                                }
                            }
                            _this.schoolUseDetail.push(classObj);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 进入各班级使用产品详情页面
             */
            goProUseDetails (row, index, time, data) {
                this.$router.push({
                    name: "schUseProDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startTime: time,
                        endTime: time,
                        seleStartDate: this.seleStartDate,
                        seleEndDate: this.seleEndDate,
                        diskId: row.diskId
                    }
                });
            }
        },
        mounted () {
            this.$nextTick(() => {
                this.getCalendar();
                //修改公共属性学校名称
                this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../../style/dataDetails.scss";
</style>
<style lang="scss">
    .tea_user_screen {
        .time-slot {
            margin-top: 0 !important;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-input-group-append, .ivu-input-group-prepend {
            background-color: #3e9bf8;
            color: #fff;
        }

        .ivu-input-icon-clear {
            padding-right: 75px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
            padding-left: 100px !important;
        }
         td.demo-table-info-left-column {
            background-color: #39c6e9;
            color: #fff;
        }

         td.demo-table-info-right-column {
            background-color: #39c6e9;
            color: #fff;
        }
        .ivu-table-cell {
            padding-left: 0 !important;
            padding-right: 0 !important;
            height: 50px;
            line-height: 50px;
        }
        .ivu-table-cell :hover{
            background:#39c6e9 !important;
            color: #fff !important;
        }
        .ivu-table-column-center {
            border-right: 1px solid #e8eaec;
        }
    }
</style>
